
import { Vue, Component, Prop } from "vue-property-decorator";

interface RequiredServicesData {
  support_type: string[];
  frequency: string;
}

@Component
export default class RequiredServices extends Vue {
    @Prop() readonly data!: RequiredServicesData;
}
